import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormField } from '../../index';

@Component({
  selector: 'crm-form-field-universal',
  templateUrl: './universal.component.html',
})
export class FormFieldUniversalComponent {
  @Input() parentFormGroup: UntypedFormGroup;
  @Input() field: FormField;
}
